import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { CommonStyles } from '../styles/Styles';
import { MultiTextComponent } from './quizzing/MultiTextComponent';
import { ButtonComponent } from './quizzing/ButtonComponent';
import { TextComponent } from './quizzing/TextComponent';
import { dataItem } from '../data/data';
import { AppHelper } from '../helpers/AppHelper';
import { ValidationHelper } from '../common/helpers/ValidationHelper';
import { AppTheme } from '../styles/AppTheme';
import { AppConfig } from '../AppConfig';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Icon from '@material-ui/core/Icon';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Helper } from '../common/helpers/Helper';

export class SubmitConfirmation extends Component {
  constructor(props) {
    super(props);
  }

  checkBox() {
    return (
      <FormControlLabel
        control={
          <Checkbox
            checked={this.props.submitAnswerPopup}
            onChange={this.props.handleCheckbox}
            value={'submitAnswerPopup'}
            color='primary'
            checkedIcon={
              <div className={css(Styles.icon)}>
                <Icon className={css(Styles.checkedIcon)}>done</Icon>
              </div>
            }
            icon={
              <div className={css(Styles.icon)} />
            }
            className={css(CommonStyles.controlLabel)}
          />
        }
        label={'Don’t ask again'}
        classes={{
          label: css(CommonStyles.formLabel, Styles.customPadding)
        }}
        className={css(CommonStyles.innerSelection, Styles.innerSelection)}
      />
    )
  }

  render() {
    return (
      <Dialog
        open={this.props.confirmationDialog}
        onClose={this.props.confirmationDialogClose}
        scroll='paper'
        classes={{
          paperWidthSm: css(Styles.dialog),
          scrollPaper: css(Styles.scrollPaper)
        }}
      >
        <DialogTitle className={css(Styles.dialogTitle)}>
          <div className={css(Styles.dialogTitleContainer)}>
            <p className={css(Styles.dialogTitleTxt)}>Ready to submit?</p>
          </div>
        </DialogTitle>
        <DialogContent className={css(Styles.dialogContent)}>
          <p className={css(Styles.dialogContentData)}>
            {Helper.getString('submitWarning')}
          </p>
          {this.checkBox()}
        </DialogContent>
        <DialogActions className={css(Styles.dialogActions)}>
          <Button
            variant='contained'
            onClick={() => this.props.confirmationDialogClose()}
            className={css(Styles.buttonContainerSecond)}
          >
            CANCEL
          </Button>
          <Button
            variant='contained'
            onClick={() => this.props.onSubmit()}
            className={css(Styles.buttonContainerSecond)}
          >
            SUBMIT
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

const Styles = StyleSheet.create({

  dialog: {
    maxWidth: 400,
    borderRadius: 31,
    '@media (max-width: 767px)': {
      maxWidth: 'unset',
    }
  },
  dialogTitleContainer: {
    display: 'flex',
  },
  dialogTitleTxt: {
    color: AppTheme.primaryColor,
    margin: 0,
    fontSize: AppTheme.dialogTitleFontSize,
    fontWeight: 'normal',
    '@media (max-width: 767px)': {
      fontSize: AppTheme.dialogTitleFontSizeBelow767,
    }
  },
  dialogContent: {
    padding: 24,
    paddingTop: 0,
    paddingBottom: 15
  },
  dialogContentData: {
    margin: 0,
    color: AppTheme.primaryColor,
    fontSize: AppTheme.dialogContentFontSize,
    whiteSpace: 'pre-wrap',
    '@media (max-width: 767px)': {
      fontSize: AppTheme.dialogContentFontSizeBelow767,
    }
  },
  icon: {
    width: 27,
    height: 27,
    background: AppTheme.secondaryBg + '0% 0% no-repeat padding-box',
    border: '2px solid' + AppTheme.primaryColor,
    borderRadius: 10,
    zIndex: 0,
    '@media (max-width: 767px)': {
      width: 25,
      height: 25,
    }
  },
  checkedIcon: {
    fontSize: 29,
    fontWeight: 'bold',
    color: AppTheme.selectedColor,
    zIndex: 1,
    lineHeight: .8,
    '@media (max-width: 767px)': {
      fontSize: 29,
    }
  },
  customPadding: {
    paddingTop: 14,
    fontSize: 18,
    '@media (max-width: 767px)': {
      paddingTop: 12,
    }
  },
  innerSelection: {
    marginTop: 5
  },
  dialogActions: {
    padding: 24,
    paddingTop: 0,
    paddingBottom: 15
  },
  buttonContainerSecond: {
    maxWidth: 150,
    fontSize: 22,
    fontWeight: 'normal',
    borderRadius: 30,
    display: 'flex',
    alignItems: 'center',
    '@media (max-width: 767px)': {
      maxWidth: 100,
      fontSize: 16,
      borderRadius: 25,
      padding: '0px 10px',
    },
    backgroundColor: 'transparent',
    boxShadow: 'unset',
    color: AppTheme.tertiaryColor,
  },
})


// WEBPACK FOOTER //
// ./src/components/SubmitConfirmation.js